import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Paper, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import to from "await-to-js";
import { axiosWithAuth } from "../plugins/axios";

const apiUrl = process.env.REACT_APP_PIPELINE_API; 

const Dashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [autoGraderVsManual, setAutoGraderVsManual] = useState<string>("N/A");


  const fetchDashboardData = async () => {
    setLoading(true);
    const [err, response] = await to(axiosWithAuth(`${apiUrl}autoGrade/dashboard`, {}, "get")) as any;

    if (err) {
      setError("Failed to load dashboard data");
      setLoading(false);
      return;
    }

    setDashboardData(response.data);

    const [metricErr, metricResponse] = await to(axiosWithAuth(`${apiUrl}autoGrade/dashboard/overallMetrics`, {}, "get")) as any;
   
    if (metricErr) {
      setError("Failed to load overallMetrics data");
      setLoading(false);
      return;
    }
    setAutoGraderVsManual(metricResponse.data?.overallMetrics?.overallAccuracy)


    setLoading(false);
  };


  useEffect(() => {
    fetchDashboardData();
  }, []);


  if (loading) {
    return (
      <Box mt={4} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }


  if (error) {
    return (
      <Box mt={4}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }
  const formatTime = (seconds: number | null) => {
    if (!seconds || isNaN(seconds)) return "N/A";
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}m ${secs}s`;
  };


  const stats = dashboardData
    ? [
        { value: autoGraderVsManual || "N/A", label: "AutoGrader vs Manual", showIcon: true, navigateTo: "/performanceDashboard/listOfQuizzes" },
        { value: dashboardData.submissionEvaluated || "N/A", label: "Submissions Evaluated" },
        { value: dashboardData.evaluationFailed || "N/A", label: "Evaluations Failed" },
        { value: dashboardData.evaluationsInQueue || "0", label: "Evaluations-In-Queue" },
        // { value:formatTime(dashboardData.avgTimePerEvaluation), label: "Avg. Time/Evaluation" },
        // { value: formatTime(dashboardData.fastestEvaluation), label: "Fastest Evaluation" },
      ]
    : [];

  const handleNavigation = (path: string) => {
    navigate(path);
  };


//   return (
//     <Box display="flex">
//       {/* Main Content */}
//       <Box flexGrow={1} p={4}>
//         {loading ? (
//           <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Grid container spacing={3}>
//             {stats.map((stat, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Paper 
//                   elevation={2} 
//                   sx={{ p: 4, textAlign: "center", height: "150px", display: "flex", flexDirection: "column", justifyContent: "center" }}
//                 >
//                   <Typography variant="h4" fontWeight={600}>
//                     {stat.value}
//                   </Typography>
//                   <Typography variant="body1" mt={1}>
//                     {stat.label}
//                   </Typography>
//                   {stat.showIcon && (
//                     <Box display="flex" justifyContent="center" mt={1}>
//                       <svg 
//                         xmlns="http://www.w3.org/2000/svg" 
//                         viewBox="0 0 24 24" 
//                         width="24" 
//                         height="24" 
//                         color="#000000" 
//                         fill="none"
//                         style={{ cursor: "pointer", transition: "transform 0.2s" }}
//                         onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.2)"}
//                         onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
//                         onClick={() => handleNavigation(stat.navigateTo)}
//                       >
//                         <path d="M10 8L13.3322 11.0203C14.2226 11.8273 14.2226 12.1727 13.3322 12.9797L10 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//                         <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
//                       </svg>
//                     </Box>
//                   )}
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         )}
//       </Box>
//     </Box>
//   );
// };
return (
  <Box display="flex">
    <Box flexGrow={1} p={4}>
      <Grid container spacing={3}>
        {stats.map((stat, index) => (
          <Grid item xs={18} sm={9} md={6} key={index}>
            <Paper elevation={2} sx={{ p: 4, textAlign: "center", height: "150px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <Typography variant="h4" fontWeight={600}>{stat.value}</Typography>
              <Typography variant="body1" mt={1}>{stat.label}</Typography>
              {stat.showIcon && (
                <Box display="flex" justifyContent="center" mt={1}>
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    width="24" 
                    height="24" 
                    color="#000000" 
                    fill="none"
                    style={{ cursor: "pointer", transition: "transform 0.2s" }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.2)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                    onClick={() => handleNavigation(stat.navigateTo)}
                  >
                    <path d="M10 8L13.3322 11.0203C14.2226 11.8273 14.2226 12.1727 13.3322 12.9797L10 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                </Box>
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);
};

export default Dashboard;